{{#if device}}
	<a href="{{link}}">
		{{{DEVICE_STATUS device.status}}}&nbsp;<b>{{text}}</b>
	</a>
	<div class="js-popup-content" id="{{device.id}}">
		<center><i class="fa fa-spin fa-spinner m-t-15"></i></center>
	</div>
{{else}}
	<b>{{text}}</b>
{{/if}}
